import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Upload, Icon } from 'antd';

import requestAPI from '../../../helpers/requestAPI';
import { setChangedBrowserDataWhenAdd } from '../../../actions';
import { toastSuccess, toastError } from '../../../utils/toastr';

const UploadModal = ({ visible, changeVisible, site_id, directory, filesTree, setChangedBrowserDataWhenAdd }) => {
	const [ fileList, setFileList ] = useState([]);

	const { Dragger } = Upload;

	const sendData = () => {
		fileList.forEach((file) => {
			const route = file.type === 'application/zip' ? 'dir_upload' : 'file_upload';
			const data = JSON.parse(filesTree[0].value);
			const addedFile = {
				value: JSON.stringify({
					name: file.type === 'application/zip' ? file.name.split('.')[0] : file.name,
					siteName: data.siteName,
					siteId: site_id,
					isFolder: file.type === 'application/zip' ? true : false,
					directory: directory ? directory : '/'
				}),
				label: file.type === 'application/zip' ? file.name.split('.')[0] : file.name,
				showCheckbox: false
			};

			const formData = new FormData();

			formData.append('files[]', file);

			const params = {
				routeParams: {
					route
				},
				method: 'POST',
				additionalQueryStringParams: {
					site_id,
					directory
				},
				data: formData
			};

			requestAPI(params)
				.then((response) => {
					if (response.data.ms === 'Ошибка' || response.status !== 200) {
						toastError('Something went wrong!', 'Error');
					} else {
						toastSuccess('Your file has been uploaded.', 'Done!');
						setChangedBrowserDataWhenAdd(addedFile);
					}
				})
				.catch((err) => {
					toastError(err, 'Error');
				});
		});
	};

	const handleSubmit = () => {
		changeVisible();
		sendData();
	};

	const props = {
		name: 'file',
		multiple: true,
		onRemove: (file) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			setFileList(newFileList);
		},
		beforeUpload: (file, filelist) => {
			setFileList([ ...fileList, ...filelist ]);
			return false;
		},
		fileList
	};

	return (
		<Modal title="Upload:" visible={visible} onCancel={changeVisible} onOk={handleSubmit} okText="Upload">
			<Dragger {...props}>
				<p className="ant-upload-drag-icon">
					<Icon type="inbox" />
				</p>
				<p className="ant-upload-text">Click or drag file to this area to upload</p>
				<p className="ant-upload-hint">
					Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
				</p>
			</Dragger>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		site_id: state.selectedElement.siteId,
		directory: state.selectedElement.directory,
		filesTree: state.files.browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	setChangedBrowserDataWhenAdd: (data) => dispatch(setChangedBrowserDataWhenAdd(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);
